<template>
<div>
    <!-- header -->
    <div class="jumbotron jumbotron-fluid bg-info">
        <div class="container">
            <h1 class="display-4 text-white">
                {{title}}
            </h1>
            <!-- <img src="images/logo.png" width="80px" height="76px" border="0" alt="logo" /> -->
        </div>
    </div>

    <div class="container">
        <!-- <div class="row">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link" v-bind:class="{ active: isActive }" v-on:click="isActive=!isActive">Content</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-bind:class="{ active: !isActive }" v-on:click="isActive=!isActive">File upload</a>
                </li>
            </ul>
        </div> -->

        <div class="row mt-4" v-show="!isEditing">
            <div class="col-md-2">section</div>
            <div class="col-md-3">
                <select class="form-control" v-model="selected" v-on:change="getData(selected)">
                    <option v-for="option in sections">{{option}}</option>
                </select>
            </div>
            <!-- <div class="col-md-1">
                <button type="button" class="btn btn-primary" v-bind:disabled="selected==''" @click="addNewRow(selected)"><i class="fa fa-plus" aria-hidden="true"></i> add</button>
            </div> -->
            <br>
            <br>
        </div>

        <div class="row" v-show="!isEditing" v-for="(q, index) in quarks">
            <!-- <div class="col-md-1 border"> {{q.id}} </div> -->
            <div class="col-md-1 border border" @click="editQuark(0, index)"> {{q.language}} </div>
            <div class="col-md-2 border border-left-0" v-html="q.title" @click="editQuark(1, index)"> </div>
            <div class="col border border-left-0" v-html="q.content" @click="editQuark(2, index)"> </div>
            <!-- <div class="col-md-1 border border-left-0" @click="deleteRow(index, q.id)"> <i class="fa fa-lg fa-trash"></i> </div> -->
        </div>

        <div class="row my-2" v-show="isEditing">
            <div class="col-md-1">
                <button type="button" class="btn btn-primary" @click="closeEditor">
                    <i class="fa fa-lg fa-save"></i> save
                </button>
            </div>
            <div class="col-md-1">
                <button type="button" class="btn btn-primary" @click="closeEditor">
                    <i class="fa fa-lg fa-times"></i> cancel
                </button>
            </div>
        </div>

        <div class="row" v-show="isEditing">
            <div class="col-md-12">
                <ckeditor v-model="content" :config="config" @blur="onBlur($event)" @focus="onFocus($event)">
                </ckeditor>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from "vue"
import VuejsDialog from "vuejs-dialog"
Vue.use(VuejsDialog)

import axios from 'axios'
import utils from '../js/utils'

import CKEDITOR from 'ckeditor'
import Ckeditor from './vue-ckeditor'

export default {
    components: {
        Ckeditor
    },

    data: () => ({
        isActive: true,
        isEditing: false,
        editColumn: 0,
        lastIndex: -1,
        selected: '',
        content: '',
        config: {
            toolbar: 'Basic',
            // toolbar: [
            //     ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript']
            // ],
            // enterMode: CKEDITOR.ENTER_BR,
            allowedContent: true,
            height: 600
        },
        title: 'CMS',
        sections: ['', 'translations', 'portfolio', 'about', 'links', 'contact', 'impressum', 'privacy'],
        quarks: [],
        baseUrl: '/db-sqlite.php/quarks',
    }),

    created() {
        console.clear();
    },

    methods: {
        onBlur(editor) {
            console.clear();
            console.log('onBlur');

            // if (this.content != editor) {
            console.log('changed');

            switch (this.editColumn) {
                case 0:
                    var lang = utils.strip_tags(editor);
                    lang = lang.replace(/(\r\n\t|\n|\r\t)/gm, "");
                    this.quarks[this.lastIndex].language = lang;
                    break;
                case 1:
                    this.quarks[this.lastIndex].title = utils.strip_tags(editor);
                    break;
                case 2:
                    this.quarks[this.lastIndex].content = editor;
                    break;
            }

            this.updateRow(this.quarks[this.lastIndex]);
            // }
        },

        onFocus(editor) {
            console.log('onFocus');
            // console.log(editor)
        },

        // edit quark row
        editQuark(column, index) {
            console.log(column, index);
            this.editColumn = column;
            this.lastIndex = index;
            this.isEditing = true;
            switch (column) {
                case 0:
                    this.content = this.quarks[index].language;
                    break;
                case 1:
                    this.content = this.quarks[index].title;
                    break;
                case 2:
                    this.content = this.quarks[index].content;
                    break;
            }
        },

        closeEditor() {
            this.isEditing = false;
        },

        // get rows
        getData(selected) {
            this.quarks = [];

            var url = this.baseUrl + '/section/' + selected;
            console.log(url);

            axios.get(url)
                .then(response => {
                    console.log(response);
                    if (!response.data.error) {
                        this.quarks = response.data;
                    } else {
                        console.log('Error', response.data.error.code, ':', response.data.error.status);
                        // this.$toast.open('Regel verwijderd')
                    }
                })
                .catch(e => {
                    // this.errors.push(e)
                    //console.log(e);
                })
        },

        // update row in database
        updateRow(row) {
            var config = {
                headers: {
                    "X-HTTP-Method-Override": "PUT"
                }
            }

            var url = this.baseUrl + '/' + row.id;
            console.log(row);
            console.log(url);

            axios.post(url, row, config)
                .then(function(response) {
                    console.log(response.data);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },

        // add new row to database
        addNewRow: function(selected) {
            console.clear();
            console.log('add');

            var newRow = {
                section: selected,
                language: '',
                content: ''
            }

            var url = this.baseUrl;
            axios.post(url, newRow)
                .then(response => {
                    console.log(response);
                    var result = response.data.success;
                    if (result && result.code == 201) {
                        console.log(result.code, result.status);
                        // this.rows.push(newRow);
                    }
                    this.getData(selected);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },

        // delete row from database
        deleteRow: function(index, id) {
            this.$dialog.confirm('Are you sure to delete this row?', {
                    okText: 'OK',
                    cancelText: 'Cancel',
                })
                .then((dialog) => {
                    // delete row from database
                    var url = this.baseUrl + '/' + id;
                    console.log(url);
                    axios.delete(url)
                        .then(response => {
                            if (response.data.success) {
                                // delete record
                                this.quarks.splice(index, 1);

                                console.log('deleted');
                            } else {
                                console.log('Error', response.data.error.code, ':', response.data.error.status);
                                // this.$toast.open('Regel verwijderd')
                            }
                        })
                        .catch(e => {
                            console.log(e);
                        });
                })
                .catch((dialog) => {
                    console.log('Clicked on cancel')
                });


        }
    }
}
</script>

<style>
.dg-btn {
    border-width: 1px;
    font-weight: normal;
}
</style>
